import { render, staticRenderFns } from "./course_teacherorder_management.vue?vue&type=template&id=c655c394&scoped=true&"
import script from "./course_teacherorder_management.vue?vue&type=script&lang=js&"
export * from "./course_teacherorder_management.vue?vue&type=script&lang=js&"
import style0 from "./course_teacherorder_management.vue?vue&type=style&index=0&id=c655c394&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c655c394",
  null
  
)

export default component.exports